/*Recurso: ptCatalogs - Variables y rutinas store que almacenan la respuesta del API y su manipulación en el front
  Tareas:
    GetAllEvidence    //Catálogo de Evidencias    //*RP
    GetAllCycles      //Catálogo de Ciclos        //*RP
    GetAllFeatures 
*/
//elementos stores: elementos que llenamos con inf. del api y otros elementos captados del front o para manejo del front
//funciones stores: rutinas que captan o modifican los elementos store
//response: { config: {}, hearders:{}, request:{}, data: { informacion: {}, resultado: {}, contenido: [{ }] } } //esto trae la lectura de api

import { green } from "@mui/material/colors";
import create from "zustand";

const ptCatalogsStore = create((set:any, get:any) => ({

  objErrorPtCatalogsStore: { hasError: false, url: '', body:'',  recurso:"ptCatalogs", componente:'', idresul: 0, desresul:'', menu:''}, //se llena con la información del api si éste tiene error
   
    //*Limpia objeto de error cuando éste ya se mostro en VentanaObjeErrorAPI  
    limpiaObjErrorPtCatalogsStore: () => {
      let paso = { hasError: false, url:'', body:'', recurso:'ptCatalogs', componente:'', idresul:0, desresul:'', menu:''}
      set( { objErrorPtCatalogsStore: paso } );
      //console.log('PtCatalogsStore - limpiaObjErrorPtCatalogsStore (sale) - objErrorPtCatalogsStore: ', get().objErrorPtCatalogsStore);
    },
                
    //*Error en api  // entra a esta función cuando el servicio cae en catch y muestra el error en VentanaObjError
    generaObjErrorPtCatalogsStore: async (responseAPI:any, h:any, h2:any, e:any, c:any, m:any) => {
      //console.log('*generaObjErrorPtCatalogsStore (entra): ', responseAPI);
      //console.log('*generaObjErrorPtCatalogsStore (entra): h: ', h , ' h2: ',  h2 , ' e: ', e , ' c: ', c );
      let paso = { hasError: h, url:'', body:e, recurso:'ptCatalogs', componente:c, idresul:0, desresul:'', menu:m };
      if (responseAPI==undefined  || responseAPI=='Error: Network Error'){
        paso.idresul=-1;
        paso.desresul= 'Error inesperado, asegure su conexión con internet y vpn';
      }
      else if (responseAPI=='Error detectado por api en ret') {
        paso.desresul= h;
        paso.idresul= h2; 
      }
      else {
        let temp = responseAPI.config;
        paso.url = temp.url;
        if (responseAPI.data!="" && responseAPI.data!=null){
            paso.idresul=responseAPI.data.ret;
            paso.desresul= responseAPI.data.msjerror;
        }    
        else {
            paso.idresul= responseAPI.status;
            switch(responseAPI.status){
              //case 404:  paso.desresul= "El usuario no existe"; break;
              case 401:  paso.desresul= "No autorizado"; break;
              case 404:  paso.desresul= "No tiene información, error al leer la tarea del API"; break;
              default: paso.desresul= responseAPI.statusText; break;
            }
        }    
      }
      set( { objErrorPtCatalogsStore: paso } );
      console.log('::PtCatalogsStore - generaObjErrorPtCatalogsStore (sale) - objErrorPtCatalogsStore: ', get().objErrorPtCatalogsStore);
    },

  catPTEvidenciasStore: [], //response.data de la tarea:GetAllOriginStore +  elementos de uso en el front
   
    //*Tareas: GetAllEvidence // recibe el response.data y lo guarda en variable store
    guardaGetAllEvidenceStore: async (responseAPI:any) => { 
      //console.log('guardaGetAllOriginStore - responseAPI:', responseAPI)
      set ( { catPTEvidenciasStore: responseAPI } )

      get().catPTEvidenciasStore.map((e:any) => {
          e.activo=false;
          e.disabled=false;
          e.visible=false; 
      });
      //console.log (':::catPTEvidenciasStore: ', get().catPTEvidenciasStore );
      return(get().catPTEvidenciasStore);
    },

  catPTCiclosStore: [], //response.data de la tarea: GetAllProcessByFrequencyStore +  elementos de uso en el front

    //*Tareas: GetAllCycles // recibe el response.data y lo guarda en variable store
    guardaPTGetAllCyclesStore: async (responseAPI:any) => {  
      //console.log('guardaPTGetAllCyclesStore - responseAPI:', responseAPI)
      set ( { catPTCiclosStore: responseAPI})
      
      //preparamos catPTCiclosStore con lo necesario para visualizar en front
        let met = "";
        get().catPTCiclosStore.map((c:any) => {
          met = "";
          c.pt_md!.map((m:any) => {
              if (m.name != null) {   met = met + " [" + m.name + "], " };
          });
          c.name = c.name + met.substring(0, met.length-2);
          c.met = met;
        })
        //console.log (':::catPTCiclosStore: ', get().catPTCiclosStore );
        return(get().catPTCiclosStore);
    },

    //*Cargo los ciclos de Catalogs/Cycles dentro de catPtCiclosStore
    // entra desde Responsable de Proceso - useEffect
    combinaCatalogosCiclosStore: async (catC:any) => {  
      var _ = require('underscore');
      //console.log ('::catC: ', catC);

      catC.map((c:any) => { get().catPTCiclosStore.push(c) }); 

      let met = "";
      
      get().catPTCiclosStore.map((catPt:any) => {
          met = "";
          catPt.pt_md.map((m:any) => {
              if (m.name != null) { met = met + " [" + m.name + "], " }
          });
          catPt.name = catPt.name + met.substring(0, met.length-2);
      });
      console.log(':::combinaCatalogosCiclosStore-catPTCiclosStore: ', get().catPTCiclosStore) 
      let paso = _.filter(get().catPTCiclosStore, function(ar:any) { return ar.state_cycle.pt_state_description === 'Activo' });
      //console.log(':::paso: ', paso);
      set ( { catPTCiclosStore: paso } );
      console.log(':::combinaCatalogosCiclosStore-catPTCiclosStore: ', get().catPTCiclosStore)
      return(get().catPTCiclosStore);
    },
 
  catPTCaracteristicasStore: [], //response.data de la tarea: GetAllFeatures +  elementos de uso en el front
  
    //*Tareas: GetAllFeatures  / recibe el response.data y lo guarda en variable store: catPTCaracteristicasStore
    guardaPTGetAllFeaturesStore: async (responseAPI:any) => {  
      //console.log('guardaGetAllFeaturesStore - responseAPI:', responseAPI)
      set ( { catPTCaracteristicasStore: responseAPI})
      
      //preparamos catProcesosStore con lo necesario para visualizar en front
        get().catPTCaracteristicasStore.map((catEC:any) => {
          catEC.features.map((catEC_C:any) => {
            catEC_C.activo=false;
            catEC_C.nombreCorto= (catEC_C.name.length > 42) ? catEC_C.name.substring(0,42) + '...' : catEC_C.name; 
          });
        });
      //console.log (':::catPTCaracteristicasStore: ', get().catPTCaracteristicasStore );
      return(get().catPTCaracteristicasStore);
    },    
  
}));

export default ptCatalogsStore;
